export default __webpack_public_path__ + "static/media/head04_ja_pc@2x.3cecc82b.png";